import { Overlay } from '@american-autonomy/ag-ui';

import Modal from 'components/Modal';
import ModalBodyContainer from 'components/containers/ModalBodyContainer';
import ServiceIntervalsForm from 'components/forms/ServiceIntervalsForm';

import useData from './hooks/useData';
import useTranslation from './hooks/useTranslation';

import ServiceIntervalsModalFooter from './components/ServiceIntervalsModalFooter';
import ServiceIntervalsModalHeader from './components/ServiceIntervalsModalHeader';
import ServiceIntervalsModalPlaceholder from './components/ServiceIntervalsModalPlaceholder';
import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ServiceIntervalsModal: FunctionComponent<Props> = ({
    assetModels,
    className = '',
    isEditable = true,
    isLoading = false,
    isSaving = false,
    onClose,
    onSubmit,
    partsByAssetModelId,
    testId = TEST_ID,
    unavailableAssetModelIds
}) => {
    const { TITLE } = useTranslation();

    const { form, hasErrors, isSaveDisabled, onSave } = useData({
        isEditable,
        isSaving,
        onSubmit,
        partsByAssetModelId
    });

    const hasAssetModels = !isLoading && assetModels.length > 0;

    return (
        <Overlay
            className={`${className} ${styles.serviceIntervalsModal}`}
            onClose={onClose}
            testId={testId}>
            <Modal className={styles.modal}>
                <ServiceIntervalsModalHeader onClose={onClose} title={TITLE} />

                <ModalBodyContainer className={styles.body}>
                    {hasAssetModels ? (
                        <ServiceIntervalsForm
                            assetModels={assetModels}
                            form={form}
                            hasErrors={hasErrors}
                            isEditable={isEditable}
                            isSaving={isSaving}
                            partsByAssetModelId={partsByAssetModelId}
                            unavailableAssetModelIds={unavailableAssetModelIds}
                        />
                    ) : (
                        <ServiceIntervalsModalPlaceholder isLoading={isLoading} />
                    )}
                </ModalBodyContainer>

                {hasAssetModels && (
                    <ServiceIntervalsModalFooter
                        isSaveDisabled={isSaveDisabled}
                        onCancel={onClose}
                        onSave={onSave}
                    />
                )}
            </Modal>
        </Overlay>
    );
};

export default ServiceIntervalsModal;
